import { render, staticRenderFns } from "./SubHeaderHomepage.vue?vue&type=template&id=2320ed0a&"
import script from "./SubHeaderHomepage.vue?vue&type=script&lang=js&"
export * from "./SubHeaderHomepage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports